angular.module('impactx.rfx').controller('RFXPurchaserListCtrl', [RFXPurchaserListCtrl]);

function RFXPurchaserListCtrl()
{
    var buttonDefinition = [];

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfxpurchaserlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/purchaser/list',
        id: "rfxpurchaserlist",
        buttonDefinition: buttonDefinition
    };
    
    this.getMeta = function () {
        return this.meta;
    };

}